import { render, staticRenderFns } from "./CreateState.vue?vue&type=template&id=73ed5358&"
import script from "./CreateState.vue?vue&type=script&lang=js&"
export * from "./CreateState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports